import { useDispatch } from "react-redux";
import { sortedBy } from "../../features/filter/filterSlice";

export default function Sort() {
  const dispatch = useDispatch();

  const handledSorted = (e) => {
    e.preventDefault();
    const selected = e.target.value;
    dispatch(sortedBy(selected));
  };

  return (
    <div className="sidebar-content">
      <h4>Sort</h4>
      <select
        onChange={handledSorted}
        name="sort"
        id="lws-sort"
        className="w-full max-w-[150px] border-2 rounded-md text-gray-500"
      >
        <option value="">Default</option>
        <option value="newest">Newest</option>
        <option value="most_liked">Most Liked</option>
      </select>
    </div>
  );
}
